import React from 'react';
import HeroSectionHealthcare from '../components/HeroSectionHealthcare';
import LogoSection from '../components/LogoSection';
import StatsSectionHealthcare from '../components/StatsSectionHealthcare';
import TaleOfTwoOwnersSection from '../components/TaleOfTwoOwnersSection';
import TeamSection from '../components/TeamSection';
import TimelineSection from '../components/TimelineSection';
import FAQSection from '../components/FAQSection';
const HealthcareClinicsPage = () => {
  return <main className="flex-grow" data-id="element-417">
      <HeroSectionHealthcare data-id="element-418" />
      <LogoSection data-id="element-419" />
      <StatsSectionHealthcare data-id="element-420" />
      <TaleOfTwoOwnersSection data-id="element-421" />
      <TeamSection data-id="element-422" />
      <TimelineSection data-id="element-423" />
      <FAQSection data-id="element-424" />
    </main>;
};
export default HealthcareClinicsPage;